import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React, { memo } from 'react'

export interface Props {
  pageID?: string
  label: string
  languagePrefix: string | null
  URL: string
}

export const LanguageItem = memo(function LanguageItem({
  label,
  languagePrefix,
  URL,
}: Props) {
  return (
    <Anchor to={URL} lang={languagePrefix === label ? undefined : label}>
      {label}
    </Anchor>
  )
})

const Anchor = styled(Link)`
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.8px;
  line-height: 1.125rem;
  text-transform: uppercase;

  @media (max-width: 1199px) {
    font-size: 0.75rem;
    transform: translateY(0.0625rem);
  }
`
